const mixin = {
    methods: {
        resetFDNSStore() {
            this.$store.commit('updateFDNSConsultantId', '')
            this.$store.commit('updateFDNSEmpOrgId', '')
            this.$store.commit('updateFDNSSelectedReport', null)
        },
    }
}

export default mixin


// WEBPACK FOOTER //
// ./src/components/ESSProfile/FDNS/mixins.js